import {FullLengthDateRange} from './full-length-date-range';
import {TimeUnit} from './types';

// TODO(go/j/AE-315): Cleanup once minute time picker launches.
// This is to enable hiding hour/minute selection behind a feature-flag
export class FullLengthDateRangeHourMinute extends FullLengthDateRange {
  public getTimeUnitOptions(): TimeUnit[] {
    return [TimeUnit.Minute, TimeUnit.Hour, TimeUnit.Day, TimeUnit.Week, TimeUnit.Month];
  }
}
